<template>
    <v-card style="background-color: #efeded; height: 100%">
        <v-card-text>
            <v-row>
                <v-col>
                    <v-icon @click="isColorPickerOpen = !isColorPickerOpen" color="primary">mdi-brush-outline</v-icon>

                </v-col>
                <v-col class="text-left">
                    <v-btn-toggle v-model="selectedChart"
                                  shaped
                                  mandatory>
                        <v-btn value="chart1">
                            {{$t('ChartOne')}}
                        </v-btn>

                        <v-btn value="chart2">
                            {{$t('ChartTwo')}}
                        </v-btn>

                        <v-btn value="chart3">
                            {{$t('ChartThree')}}
                        </v-btn>
                    </v-btn-toggle>
                </v-col>
            </v-row>
            <v-row>
                <v-col>

                </v-col>
            </v-row>
            <!-- Color Picker Dialog -->
            <v-dialog v-model="isColorPickerOpen" max-width="400">
                <v-card>
                    <div class="card-title">
                        {{ $t('ChangeColor')}}
                    </div>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-color-picker v-model="chartColor" mode="hexa" />
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer />
                        <v-btn color="primary" text @click="isColorPickerOpen = false">
                            {{$t('Close')}}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </v-card-text>

        <v-card-text v-if="selectedChart === 'chart1'" style="margin:auto; margin-right: 140px; margin-top: 10px;">
            <ul class="mx-5">
                <li v-for="(item, index) in value.filter(x=>x.value>0)" :key="index" style="list-style:disc">
                    <div class="chart-item">
                        <div style="width:190px; font-size: 21px; color: #000;">{{ item.name }}</div>
                        <div class="chart-bar" :style="{ width: item.value + '%', backgroundColor: chartColor }"><div style="width: 50px; font-size: 21px; color: #000;">{{ item.value }}%</div></div>
                    </div>
                </li>
            </ul>
        </v-card-text>
        <v-card-text v-if="selectedChart === 'chart2'" style="margin:auto; margin-right: 170px; margin-top: 2px;">
            <table style="width:100%">
                <tr v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                    <!--<td style="width:20%"><v-icon left class="mr-1">mdi-arrow-left</v-icon></td>-->
                    <td style="padding-top: 10px; font-size: 21px; color: #000;"><table style="background-color:white;width:100%;height:35px;padding:0px 10px"><tr><td>{{ item.name }}</td></tr></table></td>
                    <td style="width: 72%; padding-top: 10px; font-size: 21px; "><div class="chart-bar" :style="{ width: item.value + '%', backgroundColor:chartColor }"><div style="width:40px; color: #000;">{{ item.value }}%</div></div></td>
                </tr>
            </table>
            <!--<div class="chart-item" v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
            <v-row>
                <v-col cols="2">
                    <table style="background-color:white;width:100%;height:35px;padding:0px 10px">
                        <tr>
                            <td>{{ item.name }}</td>
                            <td style="width:20%">
                                <v-icon left class="mr-1">mdi-arrow-left</v-icon>
                            </td>
                        </tr>
                    </table>
                </v-col>
                <v-col>
                    <div class="chart-bar" :style="{ width: item.value + '%', backgroundColor: chartColor }"><div style="width:30px">{{ item.value }}%</div></div>
                </v-col>
            </v-row>
        </div>-->
        </v-card-text>
        <v-card-text class="align-center" v-if="selectedChart === 'chart3'" style="margin: auto; margin-top: -150px; padding-bottom: 50px;">
            <table>
                <tr>
                    <td v-for="(item, index) in value.filter(x=>x.value>0)" :key="index">
                        <div class="vertical-bar" style="font-size: 21px; color: #000;">
                            <span class="valueBar" style="color: #000;">{{ item.value }}%</span>
                            <div class="barcontainer" :style="{ height: item.value + '%', backgroundColor:chartColor }"><div class="bar"></div></div>
                        </div>
                        <div class="barname" style="font-size: 21px; color: #000;"><span>{{ item.name }}</span></div>
                    </td>
                </tr>
            </table>
        </v-card-text>
    </v-card>
</template>

<script>
    export default {
        props: {
            value: {
                type: Array,
                default: () => [],
            },

        },
       /* watch: {
            value: {
                handler(newValue) {
                    alert()
                },
                immediate: true
            },
        },*/
        data() {
            return {

                selectedChart: 'chart1', // Default to horizontal view
                isColorPickerOpen: false, // Controls the dialog visibility
                chartColor: '#00bcd4', // Default chart color
            }
        }
    }
</script>

<style scoped>
    .chart-card {
        width: 30%;
        padding: 16px;
        background-color: #f5f5f5;
        border-radius: 8px;
    }

    .chart-title {
        background-color: #00bcd4;
        color: white;
        padding: 8px;
        border-radius: 4px;
        text-align: center;
    }

    .chart-item {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-bottom: 8px;
    }

    .chart-bar {
        height: 35px;
        line-height: 35px;
        color: white;
        text-align: right;
        padding-right: 8px;
        border-radius: 4px;
        min-width: 0px;
    }
    .valueBar {
    position: absolute;
    bottom: 27px;
}
    .vertical-bar {
        display: flex;
        flex-direction: column;
        align-items: center;
        height: 300px;
        position: relative;
        margin:0 10px;
        width:50px;
    }

    .barcontainer {
        position: absolute;
        bottom: 50px;
        text-align: center;
    }

    .barname {
        position1: absolute;
        bottom1: 0px;
        width: 50px;
        word-wrap: break-word;
        height: 70px;
    }

        .barname span {
            display: block;
            transform: rotate(-70deg);
            width: 210px !important;
            margin-top: 70px;
            margin-right: -30px;
            height: 10px;
        }

    .bar {
        width: 50px;
        height: 100%;
        color: white;
        text-align: center;
    }

    .titlebackground {
        background-image: url('/public/titlebackground.png');
        background-repeat: no-repeat;
        height: 51px;
        background-size: contain;
        width: 100%;
        color: white;
        padding: 0 10px;
        line-height: 51px;
        background-position: right
    }
</style>
